import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector, GridToolbarExport,
  GridToolbarFilterButton
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import React from "react";
import adminRoutes from "../adminRoutes";
import {checkPermission, PERMISSION_DICT} from "./Users_Roles_Permission";
import LocalStorage from "./LocalStorage";

function isEmptyObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  // 如果对象没有自有属性，则认为是空对象
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export default isEmptyObject

export const UnitMapper = {
  "CS":"CASE",
  "EA":"EACH",
  "OT":"OTHER",
  "PL":"PALLET"
}

export function CustomToolbar() {
  return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector
            slotProps={{ tooltip: { title: 'Change density' } }}
        />
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarExport
            slotProps={{
              tooltip: { title: 'Export data!!!!' },
              button: { variant: 'outlined'},
            }}
        />
      </GridToolbarContainer>
  );
}

export const UnitOrder = {
  "EA": 0,
  "CS": 1,
  "PL": 2,
  "OT": 3
};

export const UnitArray = [
    {
        id:1,
        value:'EA',
        label:'EACH'
    },
    {
        id:2,
        value:'CS',
        label:'CASE'
    },
    {
        id:3,
        value:'PL',
        label:'PALLET'
    },
    {
        id:4,
        value:'OT',
        label:'OTHER'
    },
]


export const PackageDefaultRows = [
    {

    }

]

export const GiftArray = [
    {
        id:1,
        value:'Y',
        label:'Yes'
    },
    {
        id:2,
        value:'N',
        label:'No'
    }
]

export const QualityCodeArray = [
    {
        id:1,
        value:'OK',
        // label:'GOOD'
        label:'Good Product'
    },
    {
        id:2,
        value:'NG',
        // label:'BAD'
        label:'Defective'
    },
    {
        id:3,
        value:'DM',
        label:'Damage'
    },
    {
        id:4,
        value:'PD',
        label:'Pending'
    }
]

export function hasEditMode(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key].mode === "edit") {
      return true;
    }
  }
  return false;
}

export function hasDuplicateWarehouses(arr) {
  const warehouseSet = new Set();
  for (const item of arr) {
    if (warehouseSet.has(item.warehouse)) {
      return true;
    } else {
      warehouseSet.add(item.warehouse);
    }
  }
  return false;
}

export const convertRoutes = (routes) => {
    // 小写化字符串的首字母
    const lowercaseFirstLetter = (string) => {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    return routes.flatMap(route => {
        // 获取图标组件，如果 icon 存在，直接包装在 <Icon> 中
        const iconName = route.meta?.icon;
        const iconComponent = iconName
            ? <Icon fontSize="small">{iconName}</Icon>
            : null;

        // 处理路由的子路由
        const children = route.children ? convertRoutes(route.children) : [];

        // 如果路由的路径是根路径并且 component 是 Layout，直接返回子路由
        if (route.path === "/" && route.component === "Layout") {
            return children;
        }

        const routeObject = {
            type: "collapse", // 全部返回 collapse
            name: route.meta?.title || route.name,
            key: route.name ? lowercaseFirstLetter(route.name) : route.path,
            icon: iconComponent,
            route: route.path.startsWith("/") ? route.path : `/${route.path}`,
            isAuth: true, // 权限控制可以根据实际需求调整
        };

        // 仅在有组件时添加 component 属性，并处理 alwaysShow 逻辑
        // if (route.component) {
        //     routeObject.component = route.alwaysShow && children.length > 0 ? null : React.lazy(() => import(`${route.component}`));
        // }

        // 如果 children 不为空，则包含 children 属性
        if (children.length > 0) {
            routeObject.children = children;
        }

        return [routeObject];
    });
};

export const keyToNodeMap = adminRoutes.reduce((acc, route) => {
    acc[route.key] = route;
    if (route.children) {
        route.children.forEach(child => {
            acc[child.key] = child;
        });
    }
    return acc;
}, {});

export const findRoutes = (keys, keyToNodeMap)=> {
    if (keys.length === 0) return null;

    const firstKey = keys[0];

    const node = keyToNodeMap[firstKey];


    if (!node) return null;

    if (!node.children) {
        // 如果没有子项，直接返回对应的 routes
        return node.route;
    }

    // 如果有子项，查找是否存在 keys 中的子项 key
    const childKeys = node.children.map(child => child.key);
    const matchingChildKey = keys.find(key => childKeys.includes(key));

    if (matchingChildKey) {
        // 返回拼接的 routes
        const parentRoute = node.route;
        const childNode = keyToNodeMap[matchingChildKey];
        return parentRoute + (childNode ? childNode.route : '');
    }

    return null;
}

export const extractKeys = (routes) => {
    let keys = [];
    routes.forEach(route => {
        if (route.key) {
            keys.push(route.key);
        }
        if (route.children && route.children.length > 0) {
            keys = keys.concat(extractKeys(route.children));
        }
    });
    return keys;
};

export const filterRoutes = (routes, keys) => {

    const userRoles = JSON.parse(localStorage.getItem('user_roles') || '[]');

    // 如果 keys 中包含 'owner_customers' 并且 user_roles 中包含 'admin'
    if (keys.includes('owner_customers') && userRoles.includes('admin')) {
        // 从 keys 中移除 'owner_customers'
        keys = keys.filter(key => key !== 'owner_customers');
    }
    return routes
        .map(route => {
            if (keys.includes(route.key)) {
                // 如果当前路由的 key 在 keys 中，检查子路由是否需要过滤
                if (route.children) {
                    const filteredChildren = filterRoutes(route.children, keys);
                    return { ...route, children: filteredChildren };
                }
                return route;
            } else if (route.children) {
                // 如果当前路由的 key 不在 keys 中，递归过滤子路由
                const filteredChildren = filterRoutes(route.children, keys);
                if (filteredChildren.length > 0) {
                    // 如果子路由中有符合条件的，返回当前路由并包含这些子路由
                    return { ...route, children: filteredChildren };
                }
            }
            // 否则，过滤掉该路由
            return null;
        })
        .filter(route => route !== null); // 过滤掉 null 值
};

export const generatePassword = () => {
    const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const allCharacters = upperCaseLetters + lowerCaseLetters + numbers;

    let password = '';

    // Ensure at least one upper case letter
    password += upperCaseLetters[Math.floor(Math.random() * upperCaseLetters.length)];

    // Ensure at least one lower case letter
    password += lowerCaseLetters[Math.floor(Math.random() * lowerCaseLetters.length)];

    // Ensure at least one number
    password += numbers[Math.floor(Math.random() * numbers.length)];

    // Generate remaining characters randomly to meet minimum length of 6
    while (password.length < 6) {
        password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
    }

    // Shuffle the password to avoid predictable patterns
    password = password.split('').sort(() => 0.5 - Math.random()).join('');

    return password;
}

function parseEnvList(raw) {
    if (!raw) return [];

    // 去掉开头和结尾的 []（如果有）
    raw = raw.trim().replace(/^\[|\]$/g, "");

    // 如果最终只剩一个值，且没有逗号
    if (!raw.includes(",")) {
        return raw ? [raw.trim()] : [];
    }

    // 按逗号分割
    return raw
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);
}
export const checkKittingVisibility = () => {
    const whiteList = parseEnvList(process.env.REACT_APP_KITTING_WHITE_LIST);
    const ownerId = LocalStorage.getItem("ownerId");
    if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
        return true
    }
    else {
        if (ownerId && whiteList.includes(ownerId)) {
            return true;
        }
    }
    return false
}

export const contactConvert = (contact = "") => {
    const index = contact.indexOf(",");

    if (index === -1) {
        return contact.trim();
    }

    const firstPart = contact.slice(0, index).trim();
    const secondPart = contact.slice(index + 1).trim();

    return `${firstPart}, ${secondPart}`;
};

